import { useDynamicLocation } from "apps/commons/hooks/useDynamicLocation";
import type { ProfileData } from "libs/codegen/property-onboarding";
import type { FunctionComponent } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useParams } from "router";
import { Footer } from "../Footer";
import { ProfileFormFields } from "../profile/ProfileFormFields";
import { useStaticDataAtomValue } from "../staticDataAtom";
import { useFooterNavigation } from "../useFooterNavigation";
import { formInvalidHandler } from "./formInvalidHandler";
import { useFormHandler } from "./useFormHandler";

interface Props {
    data: ProfileData;
}

export const ProfileForm: FunctionComponent<Props> = ({ data }) => {
    const {
        cmsData: {
            common: { back, next },
        },
    } = useStaticDataAtomValue();
    const form = useForm<ProfileData>({
        defaultValues: data,
        shouldFocusError: true,
    });
    const { mutate, isLoading } = useFormHandler();
    const { handleBack } = useFooterNavigation();
    const { propertyId } = useParams("/:lang/list-my-property/onboard/:propertyId");
    const { pathname } = useDynamicLocation();

    return (
        <FormProvider {...form}>
            <form
                id="profile-data-form"
                onSubmit={form.handleSubmit((f) => mutate(f), formInvalidHandler("profile", propertyId, pathname))}
            >
                <ProfileFormFields />
                <Footer
                    secondary={{
                        label: back,
                        disabled: isLoading,
                        dataElementName: "list-your-property-back",
                    }}
                    primary={{
                        type: "submit",
                        label: next,
                        disabled: isLoading,
                        loading: isLoading,
                        dataElementName: "list-your-property-next",
                    }}
                    onSecondary={handleBack}
                />
            </form>
        </FormProvider>
    );
};
